import { applyMiddleware, createStore } from 'redux';
import promise from 'redux-promise-middleware';

import { rootReducer } from '../reducers';

const store = createStore(rootReducer, applyMiddleware(promise));

export default store;
